module.exports = __webpack_public_path__ + "img/team-member-05.96ac490e.jpg";